import { Suspense } from 'react';
import styled from 'styled-components';


export const HeaderContainer = styled.header`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  background-color: #fff;
  padding: 16px;
  position: sticky;
  top: 0;
  z-index: 1;
  border-bottom: 1px solid #ddd;

  .logo {
    display: flex;
    align-items: center;

    img {
      height: 40px;
      margin-right: 8px;
    }

    h1 {
      font-size: 20px;
      color: #333;
      margin: 0;
    }
  }

  nav ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      display: inline-block;
      margin-right: 16px;

      a {
        color: #333;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
`;


export const Header = ({children}) => {
  return (
    <HeaderContainer>
      <div className="logo">
        <a href="/">
          <img src="/logo.png" alt="Logo" />
        </a>
      </div>
      {children}
    </HeaderContainer>
  );
}

export const LeftSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const RightSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;


export const NavContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  gap: 16px;
`;


export function NavBar({children}: {children?: React.ReactNode}) {
  return (
      <Header>
        <NavContainer>{children}</NavContainer>
      </Header>
  );
}


export default function App() {
  return (
    <Suspense fallback="loading">
      <NavBar />
    </Suspense>
  );
}
